import { defineStore } from 'pinia'
import { reactive, ref } from 'vue'

export const useModalsStore = defineStore('modals', () => {
  const activeModals = ref([])
  const modalsState = reactive({})

  const openModal = (name, state = {}) => {
    if (activeModals.value.includes(name)) return
    if (state !== undefined) {
      modalsState[name] = state
    }
    activeModals.value.push(name)
  }

  const closeModal = (name) => {
    if (!activeModals.value.includes(name)) return
    const index = activeModals.value.indexOf(name)
    if (index === -1) return
    delete modalsState[name]
    activeModals.value.splice(index, 1)
  }

  const getModalState = (name) => {
    return modalsState[name]
  }

  return {
    activeModals,
    openModal,
    closeModal,
    getModalState,
  }
})
